import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import { apiGetNews as apiGetNewsAction } from '../../../actions/NewsActions';
import { getViewYmd } from '../../../helpers/common';
import { propArrayShape, propFunc } from '../../../helpers/custom-prop-types';
import { HeaderLogoSvg } from '../../Ui/Logo';
class HeaderLoginSideMenuNotification extends Component {
    componentDidMount() {
        const { apiGetNews } = this.props;
        apiGetNews();
    }
    render() {
        const { hideMenu, notifications } = this.props;
        return (_jsxs("div", Object.assign({ className: 'header_side_menu_content notification' }, { children: [_jsx("div", { className: 'header_side_menu_top_padding' }), _jsxs("div", Object.assign({ className: 'header_side_menu_header' }, { children: [_jsx(Link, Object.assign({ to: '/mypage' }, { children: _jsx(HeaderLogoSvg, {}) })), _jsx("button", Object.assign({ className: 'close_button', onClick: hideMenu, type: 'button', value: 'hide' }, { children: _jsx("i", Object.assign({ className: 'material-icons' }, { children: "close" })) }))] })), _jsx("ul", Object.assign({ className: 'notification_rows' }, { children: notifications.length > 0 ? (notifications.slice(0, 20).map((model) => (_jsxs("li", Object.assign({ className: 'notification_row' }, { children: [_jsx("div", Object.assign({ className: 'notification_row_date' }, { children: getViewYmd(model.createdAt) })), _jsxs("div", Object.assign({ className: 'notification_row_text' }, { children: [model.action && (_jsx(Link, Object.assign({ to: model.action }, { children: model.content }))), !model.action && model.content] }))] }), model.id)))) : (_jsx("li", Object.assign({ className: 'empty_notification_row' }, { children: "\u73FE\u5728\u304A\u77E5\u3089\u305B\u306F\u3042\u308A\u307E\u305B\u3093" }))) })), _jsx("div", { className: 'header_side_menu_bottom_padding' })] })));
    }
}
HeaderLoginSideMenuNotification.propTypes = {
    apiGetNews: propFunc().isRequired,
    hideMenu: propFunc().isRequired,
    notifications: propArrayShape(),
};
HeaderLoginSideMenuNotification.defaultProps = {
    notifications: [],
};
const mapStateToProps = ({ news }) => ({
    notifications: news.list,
});
const mapDispatchToProps = (dispatch) => ({
    apiGetNews: () => dispatch(apiGetNewsAction()),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(HeaderLoginSideMenuNotification);
